import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Cushion, Grid, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import { map } from 'lodash';
import ClubLink from '../../../club-link';

const Statistics = ({ clubPrimaryColour, seasonId, teamId, name, players }) => {
  const renderPlayerStatistics = () =>
    map(players, (statistics, key) => {
      const { player, value } = statistics;
      const isLastItem = players.length === key + 1;
      const borderBottom = isLastItem ? '' : 'thinLightGrey';
      return (
        <Rectangle component="div" borderBottom={borderBottom} key={key}>
          <ClubLink
            route="team.squad.profile"
            params={{
              teamId,
              profileType: player.profile_type,
              _profile: player.name,
              profileId: player.profile_id,
              seasonId,
            }}
          >
            <a>
              <Cushion all="medium" responsive={[{ minWidth: 'tab', props: { all: 'large' } }]}>
                <Grid
                  className="grid-stats-key-player"
                  columns="60px minmax(0, 1fr) auto"
                  columnGap="small"
                  alignItems="center"
                  responsive={[{ minWidth: 'tab', props: { columnGap: 'medium' } }]}
                >
                  <Avatar image={player.img_url} includeRetina alt={name} size={60} />
                  <div>
                    <Cushion vertical="xxsmall" component="div">
                      <Typography preset="subtitle--small" color="black">
                        {player.name}
                      </Typography>
                    </Cushion>
                    <Cushion vertical="xxsmall" component="div">
                      <Typography preset="tag--large" color="silver">
                        {player.position}
                      </Typography>
                    </Cushion>
                  </div>

                  <Typography
                    align="right"
                    preset="title"
                    color={clubPrimaryColour}
                    component="div"
                  >
                    {value}
                  </Typography>
                </Grid>
              </Cushion>
            </a>
          </ClubLink>
        </Rectangle>
      );
    });

  return (
    <Shadow>
      <Rectangle fill="white" radius="rounded">
        <Cushion top="medium">
          <Cushion all="medium" responsive={[{ minWidth: 'lap', props: { all: 'medium' } }]}>
            <Typography preset="tab--active" color="black">
              {name}
            </Typography>
          </Cushion>
          {renderPlayerStatistics()}
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

Statistics.defaultProps = {
  seasonId: null,
};

Statistics.propTypes = {
  clubPrimaryColour: PropTypes.string.isRequired,
  teamId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  players: PropTypes.arrayOf(
    PropTypes.shape({
      players: PropTypes.arrayOf(
        PropTypes.shape({
          profile_id: PropTypes.string.isRequired,
          profile_type: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          position: PropTypes.string.isRequired,
          img_url: PropTypes.string.isRequired,
        }),
      ),
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
  seasonId: PropTypes.number,
};

export default Statistics;
